import { Toaster as SonnerToaster, toast as sonnerToast } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            "group rounded-xl border border-border bg-background text-foreground shadow-lg font-sans",
          title: "text-sm font-semibold tracking-tight",
          description: "text-xs text-muted-foreground",
          actionButton: "bg-primary text-primary-foreground h-8 px-3 rounded-md text-xs font-medium",
          cancelButton: "bg-muted text-muted-foreground h-8 px-3 rounded-md text-xs",
          success: "border-border",
          warning: "border-border",
          info:    "border-border",
          error:   "border-destructive/30",
        },
      }}
    />
  );
}

export const toast = sonnerToast;
